import React from 'react'
import { DialogTitle, Box, Typography } from '@mui/material'
import { StyledDialogContent } from '../../../../ui/dialogs'

import { EditProfileFormComponent } from './edit-profile-form.component'

export const EditProfileDialogComponent = ({ close, data }) => (
  <Box p={4}>
    <DialogTitle>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography variant="h4" color="primary">
          Información personal
        </Typography>
      </Box>
    </DialogTitle>
    <StyledDialogContent>
      <EditProfileFormComponent {...{ data, close }} />
    </StyledDialogContent>
    {/* <DialogActions>
      <Button onClick={close}>Cerrar</Button>
    </DialogActions> */}
  </Box>
)
